<div class="mibp-toast"
  [class.toast-info]="toast.type === ToastType.Info"
  [class.toast-error]="toast.type === ToastType.Error"
  [class.toast-success]="toast.type === ToastType.Success"
  [class.toast-warning]="toast.type === ToastType.Warning"
  [class.mibp-toast--closing]="toast.closing"
  [attr.role]="toast.type === ToastType.Error || toast.type === ToastType.Warning ? 'alert' : 'status'"
  [attr.aria-live]="toast.type === ToastType.Error || toast.type === ToastType.Warning ? 'assertive' : 'polite'">
@if (toast.title && !toast.isResourceString) {
  <h3 class="toast-title">{{ toast.title }}</h3>
}
@if (toast.title && toast.isResourceString) {
  <h3 class="toast-title"><mibp-resource-string [key]="toast.title" [macros]="toast.titleResourceStringMacros"></mibp-resource-string></h3>
}
<button type="button" aria-label="Close" class="toast-close-button" [ngStyle]="{'top': !toast.title ? '-0.7em':'-1.6em'}" (click)="dismiss.emit(toast.id)"><span>×</span></button>
@if (toast.isResourceString) {
  <div class="toast-message">
    <mibp-resource-string [key]="toast.message" [isHtml]="toast.isHtml" [macros]="toast.bodyResourceStringMacros"></mibp-resource-string>
  </div>
}
@if (!toast.isResourceString) {
  @if (!toast.isHtml) {
    <div class="toast-message">{{ toast.message }}</div>
  }
  @if (toast.isHtml) {
    <div class="toast-message" [innerHtml]="toast.message"></div>
  }
}
@if (toast.buttons.length > 0) {
  <div class="mt-2">
    @for (btn of toast.buttons; track btn.id) {
      <button type="button" (click)="activate(btn)" class="my-button my-button--secondary">
        <mibp-resource-string [key]="btn.textResourceString"></mibp-resource-string>
      </button>
    }
  </div>
}
</div>
